import {REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS} from '/enum/records.enum';

export default {
  reportName: REPORT_ELIGIBLE_CLIENT_SUPPORT_BONUS_PLUS,
};
